<template>
  <div class="container">
    <transition name="fade">
      <div id="preloader">
        <div data-loader="circle-side"></div>
      </div>
    </transition>
    <transition name="fade">
      <div id="loader_form">
        <div data-loader="circle-side-2"></div>
      </div>
    </transition>
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center mb-4 h-100">
                    <img src="../../static/img/logo-1.png" alt="mycs" width="70"/>
                  </div>
                  <div class="text-center text-uppercase mb-4">
                    <h1 v-if="language =='fr'" class="h4 text-gray-700">Bienvenue Sur MYCS</h1>
                    <h1 v-if="language =='en'" class="h4 text-gray-700">Welcome At MYCS</h1>
                    <p v-if="language =='fr'" class="d-none d-md-block h6 text-gray-500">connectez-vous pour continuer.</p>
                    <p v-if="language =='en'" class="d-none d-md-block h6 text-gray-500">login to continue.</p>
                  </div>
                  <form id="loginForm" class="user" action="javascript:void(0);">
                    <div class="form-group">
                      <input type="text" class="form-control" v-model="username" name="username" placeholder="Identifiant..." required>
                    </div>
                    <div class="form-group">
                      <input type="password" class="form-control" v-model="password" name="password" placeholder="*******" required>
                    </div>
                    <div class="form-group">
                      <select class="form-control form-control-md form-control-solid form-select selectpicker mb-2" v-model="language" name="language">
                        <option value="fr">Français</option>
                        <option value="en">English</option>
                      </select>
                    </div>
                    <transition name="fade">
                      <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                        {{messageAlert}}
                      </div>
                    </transition>
                    <button type="submit" class="btn btn-warning btn-block text-uppercase shadow-sm" v-on:click="login()" :disabled="loginProcess">
                      <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="loginProcess">
                      <span v-if="language == 'fr'" class="indicator-label text-uppercase">Se connecter</span>
                      <span v-if="language == 'en'" class="indicator-label text-uppercase">Sign in</span>
                    </button>
                  </form>
                  <p class="d-none d-md-block h6 text-center text-gray-500 mt-4">Copyright © MYCS powered by SATISFACTIVE</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#app {
  display: grid;
  height: 100vh;
}
.container {
  margin: auto;
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import axios from 'axios'
import router from '../router'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  data () {
    return {
      language: 'fr',
      username: '',
      password: '',
      isSuccess: false,
      isError: false,
      loginProcess: false,
      messageAlert: ''
    }
  },
  methods: {
    login () {
      if ($('#loginForm').isValid()) {
        this.loginProcess = true
        axios.get(this.apiUrl+'/users', {
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      }).then(res => {
          var users = res.data
          var username = this.username
          var password = this.password
          var user = users.filter(function (item) {
            return (item.username == username) && (item.password == password) && (item.role_id == 2) && (item.is_active == 1) ;
          })
          if (user.length) {
            if(this.language == 'fr') {
              var messageAlert = "connexion établie, redirection en cours."
            } else {
              var messageAlert = "connection established, redirection in progress."
            }
            localStorage.setItem('std_language', this.language)
            localStorage.setItem('std_user', JSON.stringify(user[0]))
            this.isSuccess = true
            this.isError = false
            this.messageAlert = messageAlert
            this.username = ''
            this.password = ''
            setTimeout(function () {
              this.loginProcess = false
                router.push({
                  name: 'Home'
                })
            }, 1000)
          } else {
            if(this.language == 'fr') {
            var messageAlert = "identifiant ou mot de passe incorrect!"
            } else {
              var messageAlert = "incorrect username or password !"
            }
            this.loginProcess = false
            this.messageAlert = messageAlert
            this.isError = true
            this.isSuccess = false
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  mounted() {
    setTimeout(async function() {
      $('#preloader').fadeOut('slow')
		}.bind(this), 500);
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue